import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MainService } from '../../service/main.service';
import { ApiUrls } from '../../apiRouts';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToasterServiceService } from '../../service/toaster.service';
import { ConfirmDialog } from '../../shared/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-district',
  templateUrl: './district.component.html',
  styleUrl: './district.component.scss'
})
export class DistrictComponent implements OnInit {
  districtData: any;
  DistrictForm: any = FormGroup;
  buttonclick: boolean = false;
  submitted: boolean = false;
  districtListData: any[] = [];
  @ViewChild('scroll', { read: ElementRef })
  public scroll!: ElementRef<any>;

  constructor(
    private location: Location,
    private mainService: MainService,
    private toasterService: ToasterServiceService,
    private router: Router,
    private fb: FormBuilder,
    public dialog: MatDialog,) {
    this.DistrictForm = this.fb.group({
      district_name: ['', [Validators.required]],
      district_id: [0],
    })
  }

  ngOnInit() {
    this.getDistrict();
  }

  get f() {
    return this.DistrictForm.controls;
  }

  GotoSubdivisionList(district_id: any) {
    this.router.navigate(['/city/subdivision/' + district_id]);
  }

  goBackToPrevPage() {
    this.location.back();
  }

  applySearch(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    if (!filterValue) {
      this.districtData = [...this.districtListData];
      return;
    }
    this.districtData = this.districtListData.filter((data: any) => {
      return data.district_name.toLowerCase().includes(filterValue)
    });
  }

  EditDistrict(data: any) {
    this.buttonclick = true;
    this.DistrictForm.patchValue({
      district_id: data.district_id,
      district_name: data.district_name
    });
    this.scroll.nativeElement.scrollTop = 0;
  }

  getDistrict() {
    this.mainService.getApi(ApiUrls.districtList).subscribe((res: any) => {
      if (res.status == 1) {
        this.districtData = res.district
        this.districtListData = res.district
      }
    });
  }


  districtAdd() {
    this.buttonclick = false;
    this.submitted = true;
    if (this.DistrictForm.valid) {
      let data = {
        district_id: 0,
        district_name: this.DistrictForm.value.district_name,
        Action: 'Insert',
      };
      this.mainService.postApi(ApiUrls.addDistrict, data, 1).subscribe((res: any) => {
        if (res.status == 1) {
          this.toasterService.toastSuccess(res.response);
          this.getDistrict();
        }
        else {
          this.toasterService.toastError(res.response);
        }
      });
      this.DistrictForm.reset();
      this.submitted = false;
    } else {
      this.submitted = true;
    }
  }

  districtEdit() {
    let data = {
      district_id: this.DistrictForm.value.district_id,
      district_name: this.DistrictForm.value.district_name,
      Action: 'Update',
    };
    if (this.DistrictForm.valid) {
      this.mainService.putApi(ApiUrls.editDistrict, data, 1).subscribe((res: any) => {
        if (res.status == 1) {
          this.toasterService.toastSuccess(res.response);
          this.getDistrict();
        }
      });
      this.DistrictForm.reset();
      this.buttonclick = false;
      this.submitted = false;
    } else {
      this.submitted = true
      this.buttonclick = true;
    }
  }

  openDialog(e: any, data: any): void {    
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {
        page: 'JobList'
      },
    });
    dialogRef.afterClosed().subscribe(result => {      
      if (result == 1) {
        this.deleteDistrict(data);
      } else {
        e.source.checked = !e.checked;
        data.status = e.checked == true ? 0 : 1;
      }
    });
  }

  deleteDistrict(data: any) {
    let obj = {
      district_id:Number(data.district_id),
      district_name: this.DistrictForm.value.district_name,
      Action: 'DELETE',
    };
    this.mainService.postApi(ApiUrls.addDistrict, obj, 1).subscribe((res: any) => {
      if (res.status == 1) {
        this.toasterService.toastSuccess(res.response);
        this.getDistrict();
      }
      else {
        this.toasterService.toastError(res.response);
      }
    });
  }

}

